// Change_Password.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Change_Pass.css';
import { BASE_URL } from "../../constants"; 

function Change_Password() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [Login_Id, setLogin_Id] = useState('');

  useEffect(() => {
    const storedLogin_Id = localStorage.getItem('username');
    setLogin_Id(storedLogin_Id || 'N/A');
  }, []);

  useEffect(() => {
    axios.get(`${BASE_URL}/api/user_permission`)
  }, []);


  const isPasswordStrong = (password) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{6,}$/;
    return regex.test(password);
  };

  const handlePasswordChange = async () => {
    if (!newPassword || !confirmPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (!isPasswordStrong(newPassword)) {
      alert("Password must be at least 8 characters long, contain uppercase, lowercase, number, special character, and no spaces.");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("Passwords do not match.");
      return;
    }

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        alert("Authentication token not found. Please log in again.");
        return;
      }

      const response = await axios.post(
        `${BASE_URL}/api/change_password`,
        { newPassword }, // 👈 Only sending newPassword now
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      alert(response.data.message || 'Password changed successfully.');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to change password.';
      alert(errorMsg);
    }
  };

  return (
    <div className="container-common">
      <div className="card justify-content-end">
        {/* <div className="card-header-css">
          <h3 className="text-center">Change Password</h3>
        </div> */}
        <div className="card-body">
          <h5 className="mb-4 text-secondary">
            Login Id: <strong>{Login_Id}</strong>
          </h5>
          <div className="row justify-content-start">
            <div className="form-group col-md-6 mb-3">
                <div className="form-row-grid">
                <label style={{ width: '180px' }}>New Password</label>
                <input
                    type="password"
                    className="form-control"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                />
                </div>
            </div>
            </div>
            <div className="row justify-content-start">
            <div className="form-group col-md-6 mb-3">
                <div className="form-row-grid">
                <label style={{ width: '180px' }}>Confirm New Password</label> 
                <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                />
                </div>
            </div>
            </div>

          <button className="btn btn-primary" style={{ marginTop: '10px' }} onClick={handlePasswordChange}>
            Update Password
          </button>
        </div>
      </div>
    </div>
  );
}

export default Change_Password;
